import { Product } from '@setvi/shared/interfaces';
import { ColumnsType } from '@setvi/shared/types';
import { useMemo } from 'react';
import { Price } from 'pages/products/components/products-list/useProductColumns/contents';
import { ProductName } from 'componentsV2';

interface AssociatedProductProps {
  manufacturer: boolean;
  searchQuery?: string;
}

export const useAssociatedProductColumns = ({
  manufacturer,
  searchQuery = ''
}: AssociatedProductProps) => {
  const width = useMemo(() => (manufacturer ? '85%' : '100%'), [manufacturer]);

  const productColums: ColumnsType = useMemo(
    () => [
      {
        id: 'productName',
        width,
        label: 'Product Name',
        cellContent: (product: Product) => (
          <ProductName product={product} searchQuery={searchQuery} />
        )
      },
      ...(manufacturer
        ? [
            {
              id: 'price',
              width: '15%',
              label: manufacturer ? 'List Price' : 'Sell',
              cellContent: (product: Product) => (
                <Price value={product?.price} />
              )
            }
          ]
        : [])
    ],
    [manufacturer, searchQuery, width]
  );

  return { productColums };
};
